export class ParserHelper {
    constructor() { }
    static get instance() {
        if (!ParserHelper._instance) {
            ParserHelper._instance = new ParserHelper();
        }
        return ParserHelper._instance;
    }
    getAdditionalScore(sportEvent, key) {
        if (!sportEvent.score || !sportEvent.score.additionalScores) {
            return undefined;
        }
        let value = sportEvent.score.additionalScores[key];
        return value == undefined ? undefined : value.toString();
    }
    getAdditionalScores(sportEvent, values, suffix = "") {
        return values.map(v => this.getAdditionalScore(sportEvent, v + suffix)).filter(v => v);
    }
}
;
//# sourceMappingURL=ParserHelper.js.map